import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { defaultDistrict, defaultWard } from "../../utils";
import WardControlPanel from "../controlPanel/WardControlPanel";
import useControlPanel from "src/hooks/useControlPanel";
import { NotifyConfirm } from "src/components/notify/Notify";
import { CACHE_WARD } from "src/constants/actionCache";
import useCurrentActionCache from "src/hooks/useCurrentActionCache";
import Pagination from "src/components/Pagination/Pagination";
import { path } from "src/constants/path";
import { dataStateType } from "src/constants/status";
import WardTable from "../Table/WardTable";
import {
  createADBWard,
  getListWard,
  removeWard,
  updateWard,
} from "src/apis/ADB/ward.api";
import Controls from "src/components/form/controls/Controls";

const Wards = ({
  districtId = defaultDistrict.id,
  wardId = defaultWard.id,
  setWardId,
  provinceId,
}) => {
  const [listWard, setListWard] = useState([defaultWard]);
  const { currentActionCache, setCurrentActionCache } = useCurrentActionCache();
  const [openPopup, setOpenPopup] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);

  const {
    numberPage,
    setNumberPage,
    limit,
    handleChangePage,
    startIndex,
    endIndex,
  } = useControlPanel();

  useEffect(() => {
    getListWard({ districtId }, (result) => {
      setWardId(defaultWard.id);
      setListWard([defaultWard, ...result]);
    });
    setNumberPage(1);
  }, [districtId, setNumberPage, setWardId]);

  const handleOnChange = (e) => {
    const { value } = e.target;
    setWardId(value);
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
  };

  const actionAfterUpsert = (data, resetForm) => {
    getListWard({ districtId }, (result) => {
      setWardId(defaultWard.id);
      setListWard([defaultWard, ...result]);
      setCurrentActionCache(CACHE_WARD);
      resetForm();
    });
  };

  const addOrEdit = (ward, resetForm) => {
    if (ward.id) {
      updateWard(ward.id, ward, (result) => {
        actionAfterUpsert();
      });
    } else {
      createADBWard(ward, (result) => {
        actionAfterUpsert(result, resetForm);
      });
    }
  };

  const handleDelete = (ward) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        removeWard(ward.id, (result) => {
          actionAfterUpsert();
        });
      }
    });
  };

  return (
    <div style={{ width: "100%", margin: "0 10px" }}>
      <Controls.AdministrativeSelect
        name="ward"
        label="Ward"
        value={wardId}
        onChange={handleOnChange}
        options={listWard}
        optionField={{ key: "id", value: "wardName" }}
      />

      <WardControlPanel
        currentActionCache={currentActionCache}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
        provinceId={provinceId}
      />

      <WardTable
        districtId={districtId}
        data={listWard.slice(startIndex + 1, endIndex + 1)}
        handleDelete={handleDelete}
        handleOpenPopup={handleOpenPopup}
        status={dataStateType.ACTIVE}
      />

      <Pagination
        pathname={path.cmsAdb}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={listWard.length - 1}
      />
    </div>
  );
};

export default Wards;
